import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { CadastrarExaminadorUnicampComponent } from './cadastrar-examinador-unicamp/cadastrar-examinador-unicamp.component'
import { AuthGuard } from 'src/app/utils/auth.guard'
import { UnespCoreAuthGuardService } from 'src/libs/unesp-core'
import { environment } from 'src/environments/environment'
import { CadastrarExaminadorExternoComponent } from './cadastrar-examinador-externo/cadastrar-examinador-externo.component'
import { ListagemExaminadoresComponent } from './listagem-examinadores/listagem-examinadores.component'
import { ListaConcursoExaminadorComponent } from './lista-concurso-examinador/lista-concurso-examinador.component'
import { ListaProvaExaminadorComponent } from './lista-prova-examinador/lista-prova-examinador.component'
import { ListaNotaExaminadorComponent } from './lista-nota-examinador/lista-nota-examinador.component'
import { ListaClassificacaoExaminadorComponent } from './lista-classificacao-examinador/lista-classificacao-examinador.component'
import { ListaClassificacaoPresidenteComponent } from './lista-classificacao-presidente/lista-classificacao-presidente.component'
import { RegistarDeAcordoExaminadorComponent } from './registar-de-acordo-examinador/registar-de-acordo-examinador.component'
import { VisualizarComplementosComponent } from './visualizar-complementos/visualizar-complementos.component'

const routes: Routes = [
  {
    path: 'cadastrar-interno',
    component: CadastrarExaminadorUnicampComponent,
    canActivate: [AuthGuard, UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.RH.name}`],
    },
  },
  {
    path: 'cadastrar-externo',
    component: CadastrarExaminadorExternoComponent,
    canActivate: [AuthGuard, UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.RH.name}`],
    },
  },
  {
    path: 'examinadores',
    component: ListagemExaminadoresComponent,
    canActivate: [AuthGuard, UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.RH.name}`],
    },
  },
  {
    path: 'notificar-examinadores',
    component: ListagemExaminadoresComponent,
    canActivate: [AuthGuard, UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.RH.name}`],
    },
  },
  {
    path: 'listar-concursos',
    component: ListaConcursoExaminadorComponent,
    canActivate: [AuthGuard, UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.EXAMINADOR.name}`],
    },
  },
  {
    path: 'listar-provas/:idConcurso',
    component: ListaProvaExaminadorComponent,
    canActivate: [AuthGuard, UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.EXAMINADOR.name}`],
    },
  },
  {
    path: 'listar-notas/:idConcurso/:tipoProva',
    component: ListaNotaExaminadorComponent,
    canActivate: [AuthGuard, UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.EXAMINADOR.name}`],
    },
  },
  {
    path: 'classificacao/:concursoId',
    component: ListaClassificacaoExaminadorComponent,
    canActivate: [AuthGuard, UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.EXAMINADOR.name}`],
    },
  },
  {
    path: 'registrar-de-acordo/:comissaoJulgadoraId',
    component: RegistarDeAcordoExaminadorComponent,
  },
  {
    path: 'resultado/classificacao/:concursoId',
    component: ListaClassificacaoPresidenteComponent,
    canActivate: [AuthGuard, UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.EXAMINADOR.name}`],
    },
  },
  {
    path: 'visualizar-complementos/:inscricaoId',
    component: VisualizarComplementosComponent,
    canActivate: [AuthGuard, UnespCoreAuthGuardService],
    data: {
      allowedRoles: [`${environment.roles.EXAMINADOR.name}`],
    },
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ComissaoJulgadoraRoutingModule {}
